module.exports = __webpack_public_path__ + "media/images/copied-9f799f18.png";